import React from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAllRemindersList } from '../../Services/Reminder/action';
import '../../Assets/Css/ReminderView.scss';
import moment from 'moment/moment';

const ReminderView = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();

    // Find the reminder details by ID from props
    const reminderDetails = props?.reminder?.find(item => String(item?.id) === id);

    const reminderStatus = reminderDetails?.status;
    let statusColor;

    if (reminderStatus === 'Completed') {
        statusColor = 'rgb(0, 194, 146)';
    } else if (reminderStatus === 'Pending') {
        statusColor = '#f6b000';
    } else {
        statusColor = '#D21010';
    }

    return (
        <div className='reminderView-main'>
            {/* Page Title */}
            <div className="page-title">
                <h4> Reminder </h4>
                <div className="edit-btn">
                    <button
                        type="button"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>
                </div>
            </div>

            {/* Content Section */}
            <div className='content-part'>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="left-part">
                            <div className="custom-row">
                                <div className="reminder-detail">
                                    <h5 className='reminderView-detail-divider'> Reminder Details </h5>
                                    <div className='row'>
                                        {/* Reminder Date */}
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Reminder Date</h6>
                                            </div>
                                            <div className='col-9'>
                                                <h6 className='labels'>
                                                    {reminderDetails?.date ? moment(reminderDetails.date).format("DD-MM-YYYY") : 'N/A'}
                                                </h6>
                                            </div>
                                        </div>

                                        {/* Reminder Title */}
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Reminder Title</h6>
                                            </div>
                                            <div className='col-9'>
                                                <h6 className='labels'>
                                                    {reminderDetails?.description || 'No Description'}
                                                </h6>
                                            </div>
                                        </div>

                                        {/* Status */}
                                        <div className="input-groups">
                                            <div className="col-3">
                                                <h6 className='labels'>Status</h6>
                                            </div>
                                            <div className="col-9">
                                                <div className="reminderStatus">
                                                    <div
                                                        className="reminderStatus-circle"
                                                        style={{ backgroundColor: statusColor }}
                                                    ></div>
                                                    <h6
                                                        className="reminderStatus-text"
                                                        style={{ color: statusColor }}
                                                    >
                                                        {reminderStatus || 'N/A'}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    loading: state.reminderReducer?.loading || false,
    reminder: state.reminderReducer?.reminder || [],
    modules: state.authenticationReducer?.modules || [],
    features: state.authenticationReducer?.features || [],
    user: state.authenticationReducer?.user || {},
});

const mapDispatchToProps = (dispatch) => ({
    getAllRemindersList: () => dispatch(getAllRemindersList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReminderView);
